import { colors } from '../../theme';
import React from 'react';
import styled, { css } from 'styled-components';

const svgStyle = css`
  display: block;
  fill: ${colors.n02};
  height: 120%;
  position: absolute;
  top: -10%;
  width: auto;
  z-index: 0;

  path {
    fill-rule: evenodd;
  }
`;

const SvgMainSplat = styled.svg.attrs({
  viewBox: '0 0 953.221 734.915',
  xmlns: 'http://www.w3.org/2000/svg'
})`
  ${svgStyle};

  left: 10%;
`;

const SvgSplat1 = styled.svg.attrs({
  viewBox: '0 0 976.171 797.2',
  xmlns: 'http://www.w3.org/2000/svg'
})`
  ${svgStyle};

  right: 20%;
`;

const SvgSplat2 = styled.svg.attrs({
  viewBox: '0 0 662 730.414',
  xmlns: 'http://www.w3.org/2000/svg'
})`
  ${svgStyle};

  left: 10%;
`;

const SvgSplat3 = styled.svg.attrs({
  viewBox: '0 0 884.694 699.258',
  xmlns: 'http://www.w3.org/2000/svg'
})`
  ${svgStyle};

  right: 15%;
`;

const MainSplat = () => (
  <SvgMainSplat>
    <path d="M316 727.915a7 7 0 117 7 7 7 0 01-7-7zm-53-7a7 7 0 117 7 7 7 0 01-7-7zm33-35.5a13.5 13.5 0 1113.5 13.5 13.5 13.5 0 01-13.5-13.5zm153.622-13.466c-10.343-.338-20.219-1.087-29.353-2.229a227.9 227.9 0 01-24.025-4.252 163.751 163.751 0 01-19.293-5.771 122.365 122.365 0 01-15.158-6.786 90.076 90.076 0 01-20.3-14.606 104.067 104.067 0 01-10.929-12.625c-2.19-2.877-6.584-12.94-13.237-28.174-6.074-13.9-14.391-32.947-24.389-54.044C281.071 518.425 269.481 496 257.5 474.9c-7.145-12.585-14.447-24.7-21.7-36-7.99-12.446-16.159-24.277-24.278-35.166-8.82-11.825-17.833-22.875-26.792-32.842a345.393 345.393 0 00-29.244-29.029c-12.7-11.105-24.578-22.272-35.308-33.192-10.6-10.784-20.337-21.6-28.95-32.136a344.009 344.009 0 01-22.67-30.955 244.586 244.586 0 01-16.468-29.653A174.63 174.63 0 0141.748 187.7a129.412 129.412 0 01-4.295-26.672 104.831 104.831 0 011.677-24.995 97.7 97.7 0 017.57-23.191c5.969-10.8 12.209-20.965 18.548-30.21a279.963 279.963 0 0118.937-24.688 216.17 216.17 0 0119.182-19.625 173.28 173.28 0 0119.288-15.024 146.771 146.771 0 0119.253-10.883 133.292 133.292 0 0119.077-7.2 130.049 130.049 0 0118.761-3.983A136.027 136.027 0 01198.05 0a156.729 156.729 0 0128.4 2.7 201.366 201.366 0 0126.225 6.784C269.3 14.929 284.214 21.844 296.2 27.4c1.666.773 3.388 1.571 5.026 2.325a256.729 256.729 0 0041.77 14.5c12.637 3.313 26.412 6.164 40.944 8.475 24.747 3.937 43.337 4.949 43.521 4.959.012 0 1.265.05 3.747.05 7.783 0 29.726-.5 65.283-5.113 19.808-2.57 41.028-6.05 63.071-10.343 26.532-5.166 54.57-11.575 83.334-19.047a337.246 337.246 0 0139.5-7.85 278.11 278.11 0 0137.021-2.559c49.38 0 93.3 14.386 130.527 42.757a228.657 228.657 0 0125.508 22.717 260.807 260.807 0 0122.648 26.885 305.656 305.656 0 0119.8 30.738 362.352 362.352 0 0116.952 34.268c11.973 27.7 18.148 59.3 18.355 93.917a333.5 333.5 0 01-3.343 48.192 393.2 393.2 0 01-9.523 46.582 408.116 408.116 0 01-31.1 81.029 283.489 283.489 0 01-18.324 30.8 148.657 148.657 0 01-18.011 21.884c-10.53 10.231-28.292 22.982-52.791 37.9C800.528 542.4 776.6 555.738 749 570.114c-46.948 24.452-88.882 43.718-89.3 43.91-.07.035-7.61 3.713-19.871 9.066-11.368 4.963-29.293 12.451-50.137 19.944a610.421 610.421 0 01-66.192 19.944c-25.608 6.016-48.49 9.066-68.011 9.066-1.994-.001-3.969-.033-5.867-.095zM95.5 230.415a9 9 0 109-9 9.01 9.01 0 00-9 9zm-95.5 23a13.5 13.5 0 1113.5 13.5 13.5 13.5 0 01-13.5-13.5zm13-57.5a7 7 0 117 7 7 7 0 01-7-7z" />
  </SvgMainSplat>
);

const Splat1 = () => (
  <SvgSplat1>
    <path d="M208.527 734.524s68.055 81.337 168.244 58.7 165.468-99.951 218.062-135.77c38.518-26.232 118.043-11.048 197.423 4.908 28.643 5.757 108.473 30.185 166.075-95.183S921.566 336.99 852.358 316.861s-111.614 7.118-179.342-65.141S615.339 66.028 433.094-.005q-472.4 2.888-429.526 293.2t204.959 441.329z" />
  </SvgSplat1>
);

const Splat2 = () => (
  <SvgSplat2>
    <path d="M634.889 496.236s-45.967 114.456-141.355 107.575-154.335 87.059-208.583 112.221c-108.171 50.17-238.7-38.116-259.269-153.474S-56.231 191.78 136.96 91.755s436.929-105.5 497.929-76.393c14.015 6.688 21.59 35.687 24.944 76.393 11.245 136.461-24.944 404.481-24.944 404.481z" />
  </SvgSplat2>
);

const Splat3 = () => (
  <SvgSplat3>
    <path d="M542.106 1.37c273.668-17.36 324.061 135.995 324.061 135.995 46.731 140.367-23.69 161.506-34.935 236.28s25.175 87.243 45.885 138.208 2.564 157.107-99.886 182.022-149.655-43.64-162.664-63.221c-26.392-39.726-24.843-74.44-238.077-168.053Q-22.683 452.571 1.366 292.758C25.417 132.945 93.906 93.915 158.443 62.022Q222.979 30.129 542.106 1.37z" />
  </SvgSplat3>
);

export const splats = {
  mainSplat: MainSplat,
  splat1: Splat1,
  splat2: Splat2,
  splat3: Splat3
};
